module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/005_Acknowledgments#fm-1"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Abbreviations#fm-2"
    }
  }, [_c('em', [_vm._v("Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Chapter01#ch-1"
    }
  }, [_vm._v("Introduction: The Two Horizons of the Letters of John")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Chapter01#sec-1"
    }
  }, [_vm._v("John’s Horizons and Ours")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Chapter01#sec-2"
    }
  }, [_vm._v("Genre")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Chapter01#sec-3"
    }
  }, [_vm._v("Authorship")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Chapter01#sec-4"
    }
  }, [_vm._v("Historical Contexts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Chapter01#sec-5"
    }
  }, [_vm._v("“John’s” Purpose")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Chapter01#sec-6"
    }
  }, [_vm._v("Conclusions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter02#ch-2"
    }
  }, [_vm._v("Interpretation: Theological Interpretation of 1–3 John")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter02#sec-7"
    }
  }, [_vm._v("1 John 1:1–4")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter02#sec-8"
    }
  }, [_vm._v("1 John 1:5–2:2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter02#sec-9"
    }
  }, [_vm._v("1 John 2:3–6")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter02#sec-10"
    }
  }, [_vm._v("1 John 2:7–11")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter02#sec-11"
    }
  }, [_vm._v("1 John 2:12–14")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter02#sec-12"
    }
  }, [_vm._v("1 John 2:15–17")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter02#sec-13"
    }
  }, [_vm._v("1 John 2:18–23")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter02#sec-14"
    }
  }, [_vm._v("1 John 2:24–27")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter02#sec-15"
    }
  }, [_vm._v("1 John 2:28–3:3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter02#sec-16"
    }
  }, [_vm._v("1 John 3:4–10")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter02#sec-17"
    }
  }, [_vm._v("1 John 3:11–18")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter02#sec-18"
    }
  }, [_vm._v("1 John 3:19–24")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter02#sec-19"
    }
  }, [_vm._v("1 John 4:1–6")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter02#sec-20"
    }
  }, [_vm._v("1 John 4:7–10")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter02#sec-21"
    }
  }, [_vm._v("1 John 4:11–16")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter02#sec-22"
    }
  }, [_vm._v("1 John 4:17–18")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/008_Chapter02a#sec-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 John 4:19–5:1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/008_Chapter02a#sec-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 John 5:2–4a")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/008_Chapter02a#sec-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 John 5:4b–12")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/008_Chapter02a#sec-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 John 5:13–21")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/008_Chapter02a#sec-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 John 1–3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/008_Chapter02a#sec-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 John 4–6")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/008_Chapter02a#sec-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 John 7–11")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/008_Chapter02a#sec-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 John 12–13")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/008_Chapter02a#sec-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 John 1–2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/008_Chapter02a#sec-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 John 3–4")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/008_Chapter02a#sec-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 John 5–8")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/008_Chapter02a#sec-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 John 9–10")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/008_Chapter02a#sec-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 John 11–12")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/008_Chapter02a#sec-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 John 13–15")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theological Horizons of 1–3 John")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Trinity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec2-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theological Epistemology: Knowing God")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec2-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trinitarianism in 1–3 John: Ambiguity in Speech about the Persons of the Godhead")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec2-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From God Is Love to Nicaea: Incipient Trinitarianism in 1 John")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christology")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec2-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christ the Co-priest: The Fulfillment of the Temple")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec2-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soteriology in 1–3 John: In Jesus’s Name")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec2-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In the Flesh: Incarnation and Christology in 1–3 John")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec2-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Novel but Never New: Orthodox Theology in 1–3 John")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God and Creation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec2-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Redeemable Creation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec2-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Time in 1–3 John")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec2-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Unseen World: Spirit and Spirits in 1–3 John")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec2-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On the Importance of the Physical in 1–3 John")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God’s Character")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec2-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God Beyond, God In: Transcendence and Immanence in 1 John")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec2-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Divine Pathos in 1–3 John: God’s Joy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec2-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theological Aesthetics in 1–3 John")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec2-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Love of God and the Death of God")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec2-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God Listens: Divine Passibility in 1–3 John")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Election and Eschatology")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec2-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Transformation: Soteriology and Purgatory in 1–3 John")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec2-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eternal Security and Purgatory in 1–3 John")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec2-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eternity and Election: The Economy of Election in 1–3 John")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec2-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Being Rewarded: Eschatology and Divine and Human Economics in 1–3 John")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scripture")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec2-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apostolic Authority and Truth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec2-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theological Epistemology: Community and Discernment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec2-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What a Canon! The Theological Import of 2–3 John")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Church")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec2-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Spirit of Anointing: Church as Spirit-Temple in 1–3 John")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec2-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ecclesiology in 1–3 John: The Family of God")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec2-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gender and Leadership: The Role of Women in 1–3 John")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec2-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Intolerance and the Power of Speech in 1–3 John")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec2-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("True Church and Excommunication in 2–3 John")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ethics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec2-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ethics in 1–3 John: In Him")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec2-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Open and Closed Doors: Christian Hospitality in 1–3 John")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec2-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Money in 1–3 John")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#sec2-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Power and Authority in 1–3 John")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Bibliography#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Bibliography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f02093a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004_Contents.vue
// module id = 66
// module chunks = 0